<template>
  <div style="height:100%;">
    <!-- 使用topology组件 -->
    <topology :configs="topologyConfigs" :data="data" :materials="materials" @event="onEvent" />

    <a-modal @ok="handleSaveFile" title="保存组态图文件" v-model:visible="saveDialogVisible">
      <a-row>
        <a-col :span="4">文件名:</a-col>
        <a-col :span="20">
          <a-input v-model:value="currentLayerName" />
        </a-col>
      </a-row>
    </a-modal>

    <a-modal
      @keyup.enter.native="handleSaveCustomPen"
      @ok="handleSaveCustomPen"
      title="保存自定义图元"
      v-model:visible="saveCustomPenVisible"
    >
      <a-row @keyup.enter="handleSaveCustomPen">
        <a-col :span="4">图元名称:</a-col>
        <a-col :span="20">
          <a-input v-model:value="currentCustomPen.cname" />
        </a-col>
      </a-row>
    </a-modal>
    <!--点号列表-->
    <a-modal
      :z-index="1100"
      @ok="handleSelectIot"
      title="测点列表"
      v-drag-modal
      v-model:visible="iotListDialogVisible"
      width="1100px"
    >
      <a-row :gutter="24" @keyup.enter.native="showIotList(1, 10, true)">
        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <a-input placeholder="请输入测点名称" v-model="queryParam.pointName"></a-input>
        </a-col>
        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <a-input placeholder="请输入测点编号" v-model="queryParam.pointCode"></a-input>
        </a-col>
        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <span style="margin-right:5px;">类型</span>
          <j-dict-select-tag
            @change="showIotList(1, 10, true)"
            dictCode="point_data_type"
            placeholder="请选择数据类型"
            style="width: 80%;"
            type="list"
            v-model="queryParam.dataType"
          />
        </a-col>

        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
            <a-button @click="showIotList(1, 10, true)" icon="search" type="primary">查询</a-button>
            <a-button @click="showIotList(1, 10, false)" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
          </span>
        </a-col>
      </a-row>
      <br />
      <a-row>
        <a-table
          :columns="iotColumns"
          :customRow="onClickIotRow"
          :data-source="iotDataSource"
          :loading="iotLoading"
          :pagination="iotPagination"
          :rowClassName="setIotRowClassName"
          @change="handleIotTableChange"
          size="small"
        >
          <template slot="valueColor" slot-scope="text, record">{{ getValueColText(text, record) }}</template>
          <span slot="action" slot-scope="text, record">
            <a @click="dataLine(record)">数据曲线</a>
          </span>
        </a-table>
      </a-row>
    </a-modal>
    <a-modal @ok="handleIotSetting" title="配置测点" v-model:visible="iotSettingDialogVisible">
      <a-row>
        <a-col :span="4">图形id:</a-col>
        <a-col :span="20">
          <a-input disabled v-model="currentPen.id" />
        </a-col>
      </a-row>
      <a-row style="margin-top:10px;">
        <a-col :span="4">图形名称:</a-col>
        <a-col :span="20">
          <a-input v-model="currentPen.alias" />
        </a-col>
      </a-row>
      <a-row style="margin-top:10px;">
        <a-col :span="4">测点名称:</a-col>
        <a-col :span="12">
          <a-input v-model="currentPen.pointname" />
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="6">
          <a-button @click="showIotList(1, 10, true)" type="primary">关联测点</a-button>
        </a-col>
      </a-row>
      <a-row style="margin-top:10px;">
        <a-col :span="4">测点编号:</a-col>
        <a-col :span="12">
          <a-input disabled v-model="currentPen.pointcode" />
        </a-col>
      </a-row>
    </a-modal>

    <a-modal @ok="handleDevSetting" title="关联设备" v-model:visible="devSettingDialogVisible">
      <a-row>
        <a-col :span="4">图形id:</a-col>
        <a-col :span="20">
          <a-input disabled v-model:value="currentPen.id" />
        </a-col>
      </a-row>
      <a-row style="margin-top:10px;">
        <a-col :span="4">图形名称:</a-col>
        <a-col :span="20">
          <a-input v-model:value="currentPen.alias" />
        </a-col>
      </a-row>
      <a-row style="margin-top:10px;">
        <a-col :span="4">设备名称:</a-col>
        <a-col :span="12">
          <a-input v-model:value="currentPen.devname" />
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="6">
          <a-button @click="showDevList(1, 10, true)" type="primary">关联设备</a-button>
        </a-col>
      </a-row>
      <a-row style="margin-top:10px;">
        <a-col :span="4">设备编号:</a-col>
        <a-col :span="12">
          <a-input disabled v-model:value="currentPen.devcode" />
        </a-col>
      </a-row>
    </a-modal>

    <!--设备列表-->
    <a-modal @ok="handleSelectDev" title="设备列表" v-drag-modal v-model:visible="devListDialogVisible" width="1200px">
      <a-row :gutter="24" @keyup.enter.native="showDevList(1, 10, true)">
        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <j-dict-select-tag
            @change="showDevList(1, 10, true)"
            dictCode="`iwt-wf`.dev_process,process_name,id"
            placeholder="请选择供水流域"
            style="width: 100%;"
            v-model="devQueryParam.devProcessId"
          />
        </a-col>
        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <a-input placeholder="请输入设备名称" v-model="devQueryParam.devName"></a-input>
        </a-col>
        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <j-tree-select-custom
            @change="showDevList(1, 10, true)"
            column="dev_class_code"
            dict="`iwt-wf`.dev_class,type_name,id"
            hasChildField="has_child"
            order="sort_no asc"
            pidValue="-1"
            placeholder="请选择设备类型"
            ref="treeSelect"
            returnKey="dev_class_code"
            v-model="devQueryParam.devClassCode"
          />
        </a-col>
        <a-col :lg="6" :md="8" :sm="24" :xl="6">
          <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
            <a-button @click="showDevList(1, 10, true)" icon="search" type="primary">查询</a-button>
            <a-button @click="showDevList(1, 10, false)" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
          </span>
        </a-col>
      </a-row>
      <br />
      <a-row>
        <a-table
          :columns="devColumns"
          :customRow="onClickDevRow"
          :data-source="devDataSource"
          :loading="devLoading"
          :pagination="devPagination"
          :rowClassName="setDevRowClassName"
          @change="handleDevTableChange"
          size="small"
        ></a-table>
      </a-row>
    </a-modal>

    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
    <a-modal @ok="handleJumpLayer" title="选择跳转文件" v-model="jumpDialogVisible" width="480px">
      <a-select :options="jumpLayerList" size="large" style="width: 420px" v-model:value="jumpLayerId"></a-select>
    </a-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  // 导入topology-vue组件
  import topology from 'topology-vue'
  // 需要导入topology-vue.css
  import 'topology-vue/topology-vue.css'
  import { Modal } from 'ant-design-vue'

  Vue.use(topology)
  import { defalutMenus, defalutMaterialTabs, defalutMaterials } from './data'

  import { saveAs } from 'file-saver'
  import { addTopo, getTopoGraph, updateTopoGraph, getALLTopoGraph } from '@/api/gis'
  import { addCustomItem, getALLCustomItem, deleteCustomItem } from '@/api/gis'
  import { getIotPoints, getEquipmentList, getEquipmentType } from '@/api/gis'
  import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'

  Vue.use(topology)

  //render 47164
  //dropNodes 57759
  //ondrop 57392
  //drawNodeFns 51257
  //openSocket 58003
  //Rect 46876
  //toImage 59034
  //pen.doAction(action) 58097
  //node.scale 57858
  //scale 51990
  export default {
    name: 'editor',
    components: {
      PointsLineChartModal
    },
    data: function () {
      return {
        topologyConfigs: {
          menus: defalutMenus,
          materialTabs: defalutMaterialTabs
        },
        materials: {
          system: defalutMaterials,
          images: [],
          uploadUrl: window._CONFIG.domianURL + '/sys/common/upload'
        },
        data: {
          socketEvent: false //doSocket
        },
        imageDomianURL: window._CONFIG.ossURL,
        currentLayerid: '',
        currentLayerName: '',
        saveDialogVisible: false,

        currentPen: {
          id: '',
          alias: '',
          pointcode: '',
          pointname: ''
        },
        iotSettingDialogVisible: false,
        iotListDialogVisible: false,
        iotColumns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '测点名称',
            dataIndex: 'pointName',
            align: 'center',
            sorter: true
          },
          {
            title: '测点编号',
            dataIndex: 'pointCode',
            align: 'center',
            sorter: true
          },
          {
            title: '当前值',
            align: 'right',
            dataIndex: 'timeSeriesDetail.value',
            scopedSlots: { customRender: 'valueColor' }
          },
          {
            title: '计量单位',
            align: 'center',
            dataIndex: 'dataUnit'
          },
          {
            title: '当前值时间戳',
            align: 'center',
            dataIndex: 'timeSeriesDetail.timeStamp',
            customRender: function (text) {
              return !text ? '' : text.length > 19 ? text.substr(0, 19) : text
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 100,
            scopedSlots: { customRender: 'action' }
          }
        ],
        iotDataSource: [],
        iotPagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '30', '50', '100'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共 ' + total + ' 条'
          },
          showQuickJumper: true,
          showSizeChanger: true
        },
        iotLoading: false,
        iotRowId: '',
        jumpLayerList: [],
        jumpLayerId: '',
        jumpDialogVisible: false,
        queryParam: {
          pointCode: '',
          pointName: '',
          dataType: ''
        },
        devQueryParam: {
          devName: '',
          devClassId: ''
        },
        topology: null,
        currentCustomPen: { cname: '' },
        saveCustomPenVisible: false,

        devSettingDialogVisible: false,
        devListDialogVisible: false,
        devColumns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '供水流域',
            dataIndex: 'devProcessId_dictText',
            sorter: true,
            width: '20%'
          },
          {
            title: '设备名称',
            dataIndex: 'devName',
            sorter: true,
            width: '30%'
          },
          {
            title: '表号',
            dataIndex: 'devTag',
            sorter: true,
            width: '15%'
          },
          {
            title: '设备类型',
            dataIndex: 'devClassCode_dictText',
            sorter: true,
            width: '15%'
          },
          {
            title: '设备型号',
            dataIndex: 'devTypeId_dictText',
            sorter: true,
            width: '20%'
          }
          // {
          //   title: '服役状态',
          //   dataIndex: 'serviceStatus_dictText',
          //   sorter: true,
          //   width: '10%'
          // },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align: 'center',
          //   fixed: 'right',
          //   width: 100,
          //   scopedSlots: { customRender: 'action' }
          // }
        ],
        devDataSource: [],
        devPagination: {
          total: 0,
          current: 1,
          pageSize: 10
        },
        devLoading: false,
        devRowId: ''
      }
    },
    watch: {
      $route: {
        handler (newvalue, oldvalue) {
          if (newvalue.name == 'topology-edit') {
            if (newvalue.params && oldvalue.params && newvalue.params.id != oldvalue.params.id) {
              this.setData()
            }
          }
        }
      },
      deep: true
    },
    created: function () {
      this.setData()
    },
    mounted () {
      Vue.nextTick(function () {
        window.topology.resize()
      })
      var self = this
      if (!self.topology) {
        self.topology = window.topology
      }
      if (window.registerTools) {
        window.registerTools()
        if (window.topologyTools) {
          /*for (var i = 0; i < self.materials.system.length; i++) {
              if (self.materials.system[i].name == "企业图形库") {
                self.materials.system[i].list = window.topologyTools;
                break;
              }
            }*/
          var material = self.getMaterialByName('企业图形库')
          if (material) {
            material.list = window.topologyTools
          }
        }
      }
      this.addIotComponents()
      this.addCustomComponents()
    },
    methods: {
      getMaterialByName (name) {
        for (var i = 0; i < this.materials.system.length; i++) {
          if (this.materials.system[i].name == name) {
            return this.materials.system[i]
          }
        }
        return null
      },
      setData () {
        var self = this
        if (self.topology) {
          window.topology = self.topology
        }
        if (self.$route.params && self.$route.params.id) {
          //带参数打开现有的编辑
          if (self.currentLayerid && self.currentLayerid == self.$route.params.id) {
            self.onRender()
            return
          }
          getTopoGraph(self.$route.params.id).then(res => {
            if (res.success) {
              let result = res.result
              let gjson = JSON.parse(result.topoData)
              self.data = gjson
              //替换所有上传图片路径的前缀
              if (self.data.bkImage && self.data.bkimagepath && self.data.bkimagepath == 'relative') {
                let relativepath = self.getRelativePath(self.data.bkImage)
                self.data.bkImage = self.imageDomianURL + '/' + relativepath
              }
              if (self.data.pens && self.data.pens.length > 0) {
                for (let i = 0; i < self.data.pens.length; i++) {
                  if (self.data.pens[i].name == 'image' && self.data.pens[i].imagepath) {
                    let relativepath = self.getRelativePath(self.data.pens[i].image)
                    self.data.pens[i].image = self.imageDomianURL + '/' + relativepath
                  }
                }
              }
              self.materials.images = self.data.images
              self.currentLayerid = res.result.id
              self.currentLayerName = res.result.topoName
              self.data.name = self.currentLayerName
              self.data.socketEvent = false
              self.onRender()
            }
          })
        } else {
          //不带参数新建
          this.data = {
            socketEvent: false
          }
          this.currentLayerid = ''
          this.currentLayerName = ''
        }
      },
      getRelativePath (url) {
        //如果加上/g参数，那么只返回$0匹配。也就是说arr.length = 0
        var parse_url = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/
        //re.exec(url);
        var arr = parse_url.exec(url)
        return arr[5]
      },
      onRender () {
        Vue.nextTick(function () {
          window.topology.resize()
          window.topology.scaleTo(1)
        })
      },
      Uint8ArrayToString (fileData) {
        var dataString = ''
        for (var i = 0; i < fileData.length; i++) {
          dataString += String.fromCharCode(fileData[i])
        }
        return dataString
      },
      clearIot () {
        var self = this
        var materials = self.materials.system
        for (let k = materials.length - 1; k >= 0; k--) {
          if (materials[k].type == 'iot') {
            materials.splice(k, 1)
          }
        }
      },
      addCustomComponents () {
        var self = this
        getALLCustomItem().then(res => {
          var mlist = []
          for (var i = 0; i < res.result.records.length; i++) {
            var customPen = res.result.records[i]
            try {
              mlist.push({
                name: customPen.itemName,
                image: customPen.thumbnail,
                id: customPen.id,
                data: JSON.parse(customPen.itemData)
              })
            } catch (ex) {
              continue
            }
          }
          var material = self.getMaterialByName('自定义图元')
          if (!material) {
            self.materials.system.splice(0, 0, {
              name: '自定义图元',
              expand: true,
              show: true,
              list: mlist
            })
          } else {
            material.list = mlist
          }
        })
      },
      addIotComponents () {
        var self = this
        var materials = self.materials.system
        this.$axios.get('/materials/images.json').then(function (e) {
          self.clearIot()
          for (let i = 0; i < e.data.length; i++) {
            var list = e.data[i].list
            var iotlist = []
            for (let j = 0; j < list.length; j++) {
              iotlist.push({
                name: list[j].name,
                image: list[j].url,

                id: j,
                data: {
                  text: '',
                  imageRatio: false,
                  rect: {
                    width: 100,
                    height: 100
                  },
                  name: 'image',
                  image: list[j].url
                }
              })
            }
            materials.push({
              name: e.data[i].name,
              type: 'iot',
              expand: false,
              show: true,
              list: iotlist
            })
          }
        })
      },
      handleSaveFile () {
        let self = this
        if (this.currentLayerName == '') {
          this.$message.warning('请输入图层名称！')
          return
        }
        var data = window.topology.pureData()
        var base64 = window.topology.toImage(10)
        window.topology.data.name = this.currentLayerName
        var layer_json = {
          topoName: this.currentLayerName,
          topoData: JSON.stringify(window.topology.pureData()),
          snapshot: base64
        }

        addTopo(layer_json)
          .then(res => {
            self.currentLayerid = res.result.id
            self.$message.success('图层保存成功！')
            self.saveDialogVisible = false
          })
          .catch(err => {
            self.$message.error('图层保存失败！')
          })
      },
      handleIotSetting () {
        if (!this.currentPen.pointcode) {
          this.$message.warning('请关联测点！')
          return
        }
        /*if (!this.currentPen.alias) {
            this.$message.warning("请输入图形名称！");
            return;
          }*/
        let pens = window.topology.activeLayer.pens
        pens[0].alias = this.currentPen.alias
        pens[0].tags = [this.currentPen.pointcode]
        pens[0].pointname = this.currentPen.pointname
        this.iotSettingDialogVisible = false
      },
      handleDevSetting () {
        if (!this.currentPen.devcode) {
          this.$message.warning('请关联设备！')
          return
        }
        let pens = window.topology.activeLayer.pens
        pens[0].alias = this.currentPen.alias
        pens[0].devcode = this.currentPen.devcode
        pens[0].devname = this.currentPen.devname
        this.devSettingDialogVisible = false
      },
      handleSelectIot () {
        if (this.iotRowId) {
          this.currentPen.pointcode = this.iotRowId.pointCode
          this.currentPen.pointname = this.iotRowId.pointName
          this.currentPen.alias = this.iotRowId.pointName
          this.currentPen.dataType = this.iotRowId.dataType
          this.iotListDialogVisible = false
          if (!this.iotSettingDialogVisible) {
            let pens = window.topology.activeLayer.pens
            pens[0].alias = this.currentPen.alias
            pens[0].tags = [this.currentPen.pointcode]
            pens[0].pointname = this.currentPen.pointname
            pens[0].dataType = this.currentPen.dataType
          }
        } else {
          this.$message.warning('请选择需要关联的测点！')
        }
      },
      handleSelectDev () {
        if (this.devRowId) {
          this.currentPen.devcode = this.devRowId.id
          this.currentPen.devname = this.devRowId.devName
          this.currentPen.alias = this.devRowId.devName
          this.devListDialogVisible = false
          if (!this.devSettingDialogVisible) {
            let pens = window.topology.activeLayer.pens
            pens[0].alias = this.currentPen.alias
            pens[0].devcode = this.currentPen.devcode
            pens[0].devname = this.currentPen.devname
          }
        } else {
          this.$message.warning('请选择需要关联的设备！')
        }
      },
      dataLine (record) {
        const pointCode = record.pointCode
        this.$refs.pointsDataLineModal.show(pointCode)
      },
      devInfo (record) {
        this.$root.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: record.id,
          type: 'modal'
        })
      },
      handleIotTableChange (page) {
        if (this.queryParam.pointCode != '' || this.queryParam.pointName != '' || this.queryParam.dataType != 'all') {
          this.showIotList(page.current, page.pageSize, true)
        } else {
          this.showIotList(page.current, page.pageSize, false)
        }
      },
      handleDevTableChange (page) {
        if (this.devQueryParam.devName != '' || this.devQueryParam.devClassId != '') {
          this.showDevList(page.current, page.pageSize, true)
        } else {
          this.showDevList(page.current, page.pageSize, false)
        }
      },
      onClickIotRow (row, index) {
        var self = this
        return {
          on: {
            click: function () {
              self.iotRowId = row
            }
          }
        }
      },
      onClickDevRow (row, index) {
        var self = this
        return {
          on: {
            click: function () {
              self.devRowId = row
            }
          }
        }
      },
      setIotRowClassName (row) {
        if (this.iotRowId && row.pointCode == this.iotRowId.pointCode) {
          return 'clickRowSty'
        } else {
          return ''
        }
      },
      setDevRowClassName (row) {
        if (this.devRowId && row.id == this.devRowId.id) {
          return 'clickRowSty'
        } else {
          return ''
        }
      },
      showIotList (page, pagesize, query) {
        if (!query) {
          this.queryParam = {}
        }

        var self = this
        var parameter = Object.assign({}, this.queryParam, {
          pageNo: page,
          pageSize: pagesize
        })
        if (parameter.pointCode) {
          parameter.pointCode = `*${parameter.pointCode}*`
        }
        getIotPoints(parameter)
          .then(res => {
            self.iotDataSource = res.result.records
            self.iotPagination = Object.assign(self.iotPagination, {
              total: res.result.total,
              current: res.result.current,
              pageSize: res.result.size
            })
            self.iotListDialogVisible = true
          })
          .catch(err => {
            this.$message.error('获取点号列表失败！')
          })
      },
      showDevList (page, pagesize, query) {
        if (!query) {
          this.devQueryParam = {}
        }
        var self = this
        var parameter = Object.assign(this.devQueryParam, {
          pageNo: page,
          pageSize: pagesize
        })
        getEquipmentList(parameter)
          .then(res => {
            self.devDataSource = res.result.records
            self.devPagination = {
              total: res.result.total,
              current: res.result.current,
              pageSize: res.result.size
            }
            self.devListDialogVisible = true
          })
          .catch(err => {
            this.$message.error('获取设备列表失败！')
          })
      },
      changeImgSize (base64, w, callback) {
        var newImage = new Image()
        // quality 为压缩的像素 越低压缩的越小,图片越模糊
        var quality = 0.1 //压缩系数0-1之间
        newImage.src = base64
        newImage.setAttribute('crossOrigin', 'Anonymous') //url为外域时需要
        var imgWidth, imgHeight
        newImage.onload = function () {
          imgWidth = this.width
          imgHeight = this.height
          var canvas = document.createElement('canvas')
          var ctx = canvas.getContext('2d')
          if (Math.max(imgWidth, imgHeight) > w) {
            if (imgWidth > imgHeight) {
              canvas.width = w
              canvas.height = (w * imgHeight) / imgWidth
            } else {
              canvas.height = w
              canvas.width = (w * imgWidth) / imgHeight
            }
          } else {
            canvas.width = imgWidth
            canvas.height = imgHeight
            quality = 0.6
          }
          ctx.clearRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
          var base64 = canvas.toDataURL('image/png', quality) //压缩语句
          callback(base64) //必须通过回调函数返回，否则无法及时拿到该值
        }
      },
      showJumpGraphList () {
        let self = this
        getALLTopoGraph().then(res => {
          self.jumpDialogVisible = true
          self.jumpLayerList = [{ value: -1, label: '无跳转' }]
          var layers = res.result.records
          for (var i = 0; i < layers.length; i++) {
            if (!layers[i].topoName) {
              continue
            }
            if (layers[i].id == self.currentLayerid) {
              continue
            }
            self.jumpLayerList.push({
              value: layers[i].id,
              label: layers[i].topoName
            })
          }
        })
      },
      handleJumpLayer () {
        let pens = window.topology.activeLayer.pens
        if (pens[0].events.length > 0) {
          for (let i = pens[0].events.length - 1; i >= 0; i--) {
            if (pens[0].events[i].value == 'goToJump') {
              pens[0].events.splice(i, 1)
            }
          }
        }
        if (this.jumpLayerId == -1) {
          pens[0].jumpid = -1
        } else {
          pens[0].jumpid = this.jumpLayerId
          pens[0].events.push({
            action: 3,
            type: 0,
            value: 'goToJump'
          })
        }

        this.jumpDialogVisible = false
      },
      handleSaveCustomPen () {
        var self = this
        if (this.currentCustomPen.cname == '') {
          this.$message.warning('请输入图元名称！')
          return
        }
        if (this.currentCustomPen) {
          var customPen = this.currentCustomPen
          var custombase64 = window.topology.toCustomPenImage(2, [customPen])
          var custom_json = {
            itemName: customPen.cname,
            itemData: JSON.stringify(customPen),
            thumbnail: custombase64
          }

          addCustomItem(custom_json)
            .then(res => {
              self.$message.success('自定义图元保存成功！')
            })
            .catch(err => {
              self.$message.error('自定义图元保存失败！')
            })
          var material = this.getMaterialByName('自定义图元')
          if (!material) {
            this.materials.system.splice(0, 0, {
              name: '自定义图元',
              expand: true,
              show: true,
              list: [
                {
                  name: customPen.cname,
                  image: custombase64,
                  id: customPen.id,
                  data: customPen
                }
              ]
            })
          } else {
            material.list.push({
              name: customPen.cname,
              image: custombase64,
              id: customPen.id,
              data: customPen
            })
          }
          this.saveCustomPenVisible = false
          this.currentCustomPen = { cname: '' }
        }
      },
      onEvent (e) {
        var self = this
        let pens = window.topology.activeLayer.pens
        switch (e.name) {
          case 'save':
            if (this.currentLayerid == '') {
              //新增图层
              this.saveDialogVisible = true
              return
            }
            var data = window.topology.pureData()
            data.images = self.materials.images
            var base64 = window.topology.toImage(10)
            self.changeImgSize(base64, 300, function (newBase64) {
              window.topology.data.name = self.currentLayerName
              var layer_json = {
                topoName: self.currentLayerName, //window.topology.data.name,
                topoData: JSON.stringify(data),
                snapshot: newBase64
              }

              //图层更新
              layer_json['id'] = self.currentLayerid
              updateTopoGraph(layer_json)
                .then(res => {
                  self.$message.success('图层保存成功！')
                })
                .catch(err => {
                  self.$message.error('图层保存失败！')
                })
            })

            break
          case 'savejson':
            var id = window.topology.id
            var name = window.topology.data.name
            console.log(id + '_' + name)
            var data = window.topology.pureData()
            var blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
            saveAs(blob, 'download.json')
            break
          case 'addImageUrl':
            if (e.params && e.params.image) {
              //window.topology.data.bkImage = e.params.image
              if (!self.materials.images) {
                self.materials.images = []
              }
              if (e.params.imagepath && e.params.imagepath == 'relative') {
                //相对路径
                self.materials.images.push({ image: e.params.image, imagepath: 'relative' })
                if (pens && pens.length > 0) {
                  pens[0].imagepath = 'relative'
                } else {
                  self.data.bkimagepath = 'relative'
                }
              } else {
                self.materials.images.push({ image: e.params.image })
              }
            }
            break
          case 'deleteImage':
            break
          case 'preview':
            sessionStorage.setItem('topologyData', JSON.stringify(window.topology.pureData()))
            sessionStorage.setItem('layername', this.currentLayerName)
            sessionStorage.setItem('layerid', this.currentLayerid)
            this.$router.push({ name: 'topology-preview', params: { id: 'preview' } })
            break
          case 'setiot':
            if (pens && pens.length == 1) {
              this.currentPen = {}
              this.currentPen.id = pens[0].id
              this.currentPen.alias = pens[0].alias || ''
              this.currentPen.pointname = pens[0].pointname || ''
              if (pens[0].tags && pens[0].tags.length > 0) {
                this.iotSettingDialogVisible = true
                this.currentPen.pointcode = pens[0].tags[0]
              } else {
                this.showIotList(1, 10, true)
              }
            }
            break
          case 'setdev':
            if (pens && pens.length == 1) {
              this.currentPen = {}
              this.currentPen.id = pens[0].id
              this.currentPen.alias = pens[0].alias || ''
              this.currentPen.devname = pens[0].devname || ''
              this.currentPen.devcode = pens[0].devcode || ''
              if (pens[0].devcode) {
                this.devSettingDialogVisible = true
              } else {
                this.showDevList(1, 10, true)
              }
            }
            break
          case 'showLine':
            break
          case 'jumpto':
            window.presetColors = [
              '#f00',
              '#00ff00',
              '#00ff0055',
              'rgb(201, 76, 76)',
              'rgba(0,0,255,1)',
              'hsl(89, 43%, 51%)',
              'hsla(89, 43%, 51%, 0.6)'
            ]
            if (pens && pens.length == 1) {
              if (pens[0].jumpid) {
                this.jumpLayerId = pens[0].jumpid
              } else {
                this.jumpLayerId = ''
              }
              this.showJumpGraphList()
            }
            break
          case 'saveCustomPen':
            if (e.params.pen && e.params.pen.name == 'combine') {
              var customPen
              customPen = e.params.pen.clone() //self.deepNodeClone(pens[0],customPen);
              if (customPen) {
                customPen.orginX = customPen.rect.x
                customPen.orginY = customPen.rect.y
                customPen.cname = ''
                this.saveCustomPenVisible = true
                this.currentCustomPen = customPen
              }
            }
            break
          case 'deleteComponent':
            if (e.params.component) {
              Modal.confirm({
                title: '是否确认删除此图元?',
                content: '',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk () {
                  deleteCustomItem(e.params.component.id)
                    .then(res => {
                      self.$message.success('删除成功！')
                    })
                    .catch(err => {
                      self.$message.error('删除失败！')
                    })
                  var material = self.getMaterialByName('自定义图元')
                  if (material && material.list) {
                    for (var j = 0; j < material.list.length; j++) {
                      if (material.list[j].id == e.params.component.id) {
                        material.list.splice(j, 1)
                        break
                      }
                    }
                  }
                },
                onCancel () {
                  console.log('Cancel')
                }
              })
            }

            break
        }
      },
      getValueColText (text, row) {
        if (!row.timeSeriesDetail) {
          return '--'
        }
        if (row.dataType === 'BOOL') {
          if (row.pointCode.toLocaleUpperCase().includes('_ALARM')) {
            text = row.timeSeriesDetail.value == 1 ? '报警' : '正常'
          } else if (row.pointCode.toLocaleUpperCase().endsWith('RUN')) {
            text = row.timeSeriesDetail.value == 1 ? '运行' : '停止'
          } else if (row.pointCode.toLocaleUpperCase().endsWith('STATE')) {
            text = row.timeSeriesDetail.value == 1 ? '运行' : '停止'
          }
        } else if (row.dataType === 'int') {
          text = parseInt(row.timeSeriesDetail.value, 10)
        }
        return text
      }
    }
  }
</script>
<style lang="less" scoped>
  .le5le-topology .file-settings .settings .tips {
    width: 100%;
    padding-left: 10px;
  }
  /deep/.clickRowSty {
    background-color: #1890ff;
    color: #fff;
  }
  /deep/.clickRowSty:hover > td {
    background-color: #1890ff;
  }
  /deep/ .ant-modal-body {
    max-height: 600px;
    overflow-y: auto;
  }
  /deep/.ant-table-tbody > tr > td {
    cursor: pointer;
  }
</style>
